import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Calculator, CheckCircle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const SimpleHowItWorks = () => {
  const steps = [
    {
      icon: FileText,
      step: "1",
      title: "Submit Your Statement",
      description: "Securely upload your current processing statement for a confidential analysis.",
      color: "blue"
    },
    {
      icon: Calculator,
      step: "2", 
      title: "Get Your Analysis",
      description: "Our experts identify hidden fees and calculate your potential savings line by line.",
      color: "green"
    },
    {
      icon: CheckCircle,
      step: "3",
      title: "Start Saving",
      description: "Switch to transparent pricing and keep thousands more in your business every month. Example: A restaurant processing $50,000/month saves $17,250 annually.",
      color: "purple"
    }
  ];

  return (
    <section className="py-20 bg-background" aria-labelledby="how-it-works-heading">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 id="how-it-works-heading" className="text-3xl md:text-4xl font-bold mb-4">
            Merchant Services South Florida – How We Help You Save
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Simple, transparent process. No high-pressure sales tactics, just honest analysis.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const colorClasses = {
              blue: "bg-blue-50 text-blue-600 border-blue-200",
              green: "bg-green-50 text-green-600 border-green-200", 
              purple: "bg-purple-50 text-purple-600 border-purple-200"
            };

            return (
              <Card key={index} className="relative border-2 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <CardContent className="p-8 text-center">
                  <div className={`w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center border-2 ${colorClasses[step.color as keyof typeof colorClasses]}`}>
                    <Icon className="h-8 w-8" />
                  </div>
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                    <span className="bg-primary text-primary-foreground text-sm font-bold px-3 py-1 rounded-full">
                      Step {step.step}
                    </span>
                  </div>
                  <h3 className="text-xl font-semibold mb-4">{step.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{step.description}</p>
                </CardContent>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute -right-4 top-1/2 transform -translate-y-1/2">
                    <ArrowRight className="h-6 w-6 text-muted-foreground" />
                  </div>
                )}
              </Card>
            );
          })}
        </div>

        <div className="text-center">
          <Link to="/free-rate-analysis">
            <Button size="lg" variant="default">
              Get Your Free Analysis Now
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SimpleHowItWorks;